<template>
  <div class="sy-class-special">
    {{text}}
  </div>
</template>

<script>
  import i18n from './i18n.js'

  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'special',
    props: {
      value: Object
    },
    data () {
      return {
        text: pageText.text
      }
    },
    created () {

    }
  }
</script>

<style lang="scss" scoped>
  sy-class-special {
    width: 100%;
    height: 100%;
  }
</style>
